import React from 'react'

import superado from 'assets/images/uam/no_superado.gif'

export default props => {
  
  return <div className="result">
    <img src={ superado } />
  </div>
}